export const manifest = {
  screens: {
    scr_yrepvm: { name: "Board Positioning (Home)", route: "/", position: {"x":160,"y":220} },
    scr_dgr6r5: { name: "About", route: "/about", position: {"x":160,"y":2200} },
    scr_qf8la4: { name: "Experiences", route: "/experiences", position: {"x":1560,"y":2200} },
    scr_ddh39l: { name: "Skills", route: "/skills", position: {"x":2960,"y":2200} },
    scr_r4w24a: { name: "Impact Metrics", route: "/impact", position: {"x":4360,"y":2200} },
    scr_2trlou: { name: "Board Competencies", route: "/board-competencies", position: {"x":160,"y":4180} },
    scr_39bjah: { name: "Track Record — Bank of Ireland", route: "/track-record", state: {"activeRole":"boi"}, position: {"x":1560,"y":4180} },
    scr_n5xiag: { name: "Track Record — MUFG", route: "/track-record", state: {"activeRole":"mufg"}, position: {"x":2960,"y":4180} },
    scr_ubf5jp: { name: "Track Record — JPMorgan Chase", route: "/track-record", state: {"activeRole":"jpm"}, position: {"x":4360,"y":4180} },
    scr_evfvy1: { name: "Track Record — Deutsche Bank", route: "/track-record", state: {"activeRole":"db"}, position: {"x":5760,"y":4180} },
    scr_2l7e8l: { name: "Track Record — Earlier Career", route: "/track-record", state: {"activeRole":"earlier"}, position: {"x":7160,"y":4180} },
    scr_1qnens: { name: "Systems Portfolio", route: "/systems", position: {"x":160,"y":6160} },
    scr_41vy3m: { name: "Governance & Education", route: "/governance", position: {"x":1560,"y":6160} },
    scr_1upafp: { name: "Contact Portal", route: "/contact", position: {"x":160,"y":8140} },
  },
  sections: {
    sec_6w17pk: { name: "Homepage", x: 0, y: 0, width: 1520, height: 1180 },
    sec_azoe0d: { name: "Core Professional Profile", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_1toy7o: { name: "Board Experience & Track Record", x: 0, y: 3960, width: 8520, height: 1180 },
    sec_890bxr: { name: "Specialized Areas", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_z1nb5b: { name: "Engagement", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_6w17pk", children: [
      { kind: "screen", id: "scr_yrepvm" },
    ] },
    { kind: "section", id: "sec_azoe0d", children: [
      { kind: "screen", id: "scr_dgr6r5" },
      { kind: "screen", id: "scr_qf8la4" },
      { kind: "screen", id: "scr_ddh39l" },
      { kind: "screen", id: "scr_r4w24a" },
    ] },
    { kind: "section", id: "sec_1toy7o", children: [
      { kind: "screen", id: "scr_2trlou" },
      { kind: "screen", id: "scr_39bjah" },
      { kind: "screen", id: "scr_n5xiag" },
      { kind: "screen", id: "scr_ubf5jp" },
      { kind: "screen", id: "scr_evfvy1" },
      { kind: "screen", id: "scr_2l7e8l" },
    ] },
    { kind: "section", id: "sec_890bxr", children: [
      { kind: "screen", id: "scr_1qnens" },
      { kind: "screen", id: "scr_41vy3m" },
    ] },
    { kind: "section", id: "sec_z1nb5b", children: [
      { kind: "screen", id: "scr_1upafp" },
    ] },
  ],
}
